import React from 'react';
import { IndicatorsContext } from './IndicatorsContext';

const IndicatorsContextProvider = (props) => {
  return <IndicatorsContext.Provider {...props} />;
};

export default IndicatorsContextProvider;
